import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class UpdatesIcon extends BaseIcon {
    getChildren = () => {
        return [
            <g transform="translate(-31 -32)">
                <>
                    <path d="M57.783,32H32.217A1.247,1.247,0,0,0,31,33.273V58.727A1.247,1.247,0,0,0,32.217,60H57.783A1.247,1.247,0,0,0,59,58.727V33.273A1.247,1.247,0,0,0,57.783,32Z" fill="none"/>
                    <path d="M32.217,33a.253.253,0,0,0-.217.273V58.727a.253.253,0,0,0,.217.273H57.783A.253.253,0,0,0,58,58.727V33.273A.253.253,0,0,0,57.783,33H32m.217-1H57.783A1.246,1.246,0,0,1,59,33.273V58.727A1.246,1.246,0,0,1,57.783,60H32.217A1.246,1.246,0,0,1,31,58.727V33.273A1.246,1.246,0,0,1,32.217,32Z" fill="#e8f1ff"/>
                </>
                <>
                    <path d="M55.382,46H34.618c-.341,0-.618-.373-.618-.833V36.833c0-.46.277-.833.618-.833H55.382c.341,0,.618.373.618.833v8.334C56,45.627,55.723,46,55.382,46Z" fill="none"/>
                    <path d="M55,45V37H35v8H55m.382,1H34.618c-.341,0-.618-.373-.618-.833V36.833c0-.46.277-.833.618-.833H55.382c.341,0,.618.373.618.833v8.334C56,45.627,55.723,46,55.382,46Z" fill="#e8f1ff"/>
                </>
                <path d="M43,50H35a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z" fill="#e8f1ff"/>
                <path d="M43,53H35a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z" fill="#e8f1ff"/>
                <path d="M43,56H35a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z" fill="#e8f1ff"/>
                <path d="M55,50H47a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z" fill="#e8f1ff"/>
                <path d="M55,53H47a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z" fill="#e8f1ff"/>
                <path d="M55,56H47a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z" fill="#e8f1ff"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 28 28'
}
